import DefaultLayout from './layouts/defaultLayout';
import ErrorView from './views/errorView';
import React from 'react';
import NotFoundView from './views/notFoundView';
import appstate from './appstate';

export const rts = Object.entries(appstate.routes()).map(([key, value]) => {
	return {
		path: value.path,
		element: value.element,
		errorElement: (
			<DefaultLayout>
				<ErrorView />
			</DefaultLayout>
		),
	};
});

export const routes = [
	...rts,
	{
		path: '*',
		element: (
			<DefaultLayout>
				<NotFoundView />
			</DefaultLayout>
		),
		errorElement: (
			<DefaultLayout>
				<ErrorView />
			</DefaultLayout>
		),
	},
];
